/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import leeCoreLex from 'bundles/epic/data/defaults/leeCoreLex.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  courseraCoachClipsPage: boolean;
  hideDegreeUpsellBannerFromCourseHome: boolean;
  enableHlsOnInCourseVideoPlayer: boolean;
  reduceDistractionHideS12nUpsellNotification: boolean;
  reduceDistractionHideDeadlineOverdueNotification: boolean;
  videoChaptersV2: 'DISABLED' | 'NO_CHAPTER_BAR' | 'CHAPTER_BAR';
  freemiumLoadTesting: boolean;
  enableUniversityFreeTextDropdown: boolean;
  enableWeeklyStreaks: boolean;
  guidedCourseNextStepsMigration: boolean;
  dailyGoalsFollowupExpVariant: 'control' | 'checkoutRedirect' | 'restoreD1Commitment';
  enableWeeklyStreaksAa: boolean;
  dailyGoalsFollowupExpVariantAa: 'control' | 'checkoutRedirect' | 'restoreD1Commitment';
  enableVerifiedSkillsEngagement: boolean;
  goalMilestonePersonalizationVariant: 'control' | 'milestonePersonalization' | 'milestonePersonalizationWithIndicator';
  defaultNumDaysForStreak: 1 | 2 | 3;
  defaultNumDaysForStreakV2: 1 | 2 | 3;
  defaultNumDaysForStreakAa: 1 | 2 | 3;
  enableMyLearningRedesign: boolean;
  removeAccomplishmentsDropdownOptions: boolean;
  hideDimmedOverlayInD1Welcome: boolean;
  disableD1WelcomeSequence: boolean;
  enableSkillsProgress: boolean;
  hideDailyGoals: boolean;
  enableSkillsEmail: boolean;
  enableContinueFromCourseCompletionCelebration: boolean;
  isStreakOnboardingGuideEnabled: boolean;
  isStreakOnboardingGuideEnabledAa: boolean;
  macroGoalsEnabled: boolean;
  enableSkillsProgressAAA: boolean;
  hideDailyGoalsAAA: boolean;
  enableSkillsEmailAAA: boolean;
};

const NAMESPACE = 'leeCoreLex';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([leeCoreLex as $TSFixMe]);

const leeCoreLexEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default leeCoreLexEpicClient;
